import React from 'react';
import { I18n } from '@fiverr-private/fiverr_context';
import { percentFormatter } from '../formatters/percent';
import { boldFormatter } from '../formatters/bold';
import { currencyFormatter } from '../formatters/currency';
import DiscountPromoCodeNotice from '../DiscountPromoCodeNotice';
import { RangesPromoCodeDiscountNoticeType } from './propTypes';

const RangesPromoCodeDiscountNotice = ({
    messageId,
    userId,
    withExpirationDate,
    discountValue,
    orderValue,
    code,
    expirationDate,
    termsAndConditionSlug,
    showPercentageDiscount
}) => {
    const discount = showPercentageDiscount ? (
        <I18n k="layout.discount_ranges_promo_code.percentage"
            params={{ discountValue: percentFormatter(discountValue / 100), orderValue: currencyFormatter(orderValue) }}
            templates={[boldFormatter]}/>
    ) : (
        <I18n k="layout.discount_ranges_promo_code.dollars"
            params={{ discountValue: currencyFormatter(discountValue), orderValue: currencyFormatter(orderValue) }}
            templates={[boldFormatter]}/>
    );

    return (
        <DiscountPromoCodeNotice discount={discount}
            messageId={messageId}
            userId={userId}
            withExpirationDate={withExpirationDate}
            code={code}
            expirationDate={expirationDate}
            termsAndConditionSlug={termsAndConditionSlug}/>
    );
};

RangesPromoCodeDiscountNotice.propTypes = RangesPromoCodeDiscountNoticeType;

export default RangesPromoCodeDiscountNotice;
